import { gql } from '@apollo/client';

const GET_ARTICLES_BY_TAXONOMY = gql`
	query GetArticlesByTaxonomy($filters: ArticlesWhere!, $limit: Int, $skip: Int) {
		all_articles(where: { AND: $filters }, limit: $limit, skip: $skip, order_by: [created_at_DESC]) {
			total
			items {
				url
				top_content {
					heading
					subheading
				}
				modular_blocks {
					... on ArticlesModularBlocksAllImages {
						all_images {
							imageConnection {
								edges {
									node {
										... on Image {
											imageConnection {
												edges {
													node {
														url
													}
												}
											}
											contain
											image_alt
										}
									}
								}
							}
						}
					}
				}
				seo {
					title
					description
					thumbnailConnection {
						edges {
							node {
								url
							}
						}
					}
				}
			}
		}
	}
`;

const GET_INSPIRATION_BY_TAXONOMY = gql`
	query GetInspirationByTaxonomy($filters: ImageDetailWhere!, $limit: Int, $skip: Int) {
		all_image_detail(where: { AND: $filters }, limit: $limit, skip: $skip, order_by: [created_at_DESC]) {
			total
			items {
				url
				heading
				tiles {
					heading
					tileConnection {
						edges {
							node {
								... on Tile {
									backend_name
								}
							}
						}
					}
				}
				imageConnection {
					edges {
						node {
							... on Image {
								imageConnection {
									edges {
										node {
											url
											dimension {
												width
												height
											}
										}
									}
								}
								contain
								image_alt
								shop_the_look {
									pinpoints {
										position_horizontal
										position_vertical
										tileConnection {
											edges {
												node {
													... on Tile {
														manual
														backend_name
														header
														display_name
														static_url
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
				system {
					created_at
				}
			}
		}
	}
`;

const GET_FAQ_BY_TAXONOMY = gql`
	query GetFaqByTaxonomy($filters: FaqWhere!) {
		all_faq(where: { AND: $filters }, order_by: [created_at_DESC]) {
			total
			items {
				question
				answer
			}
		}
	}
`;

export { GET_ARTICLES_BY_TAXONOMY, GET_INSPIRATION_BY_TAXONOMY, GET_FAQ_BY_TAXONOMY };
